import { defineMessages } from "react-intl";

const messages = defineMessages({
  mismatched: {
    id: "occBalancing.utils.mismatched",
    defaultMessage: "MismatchedPage",
  },
  misbilled: {
    id: "occBalancing.utils.misbilled",
    defaultMessage: "MisbilledPage",
  },
});

export default messages;
